module.exports = __webpack_public_path__ + "static/media/FarmlandScene-menuicon_OnState.5c24d53e.png";